import React, { useState, useEffect } from 'react'
import { CustomModal } from '../../CustomModal/CustomModal'
import { getScanCamera, setScanCamera } from '../../../helpers/helpers'
import { t } from 'i18next'
import { ButtonWhite } from '../../Buttons/ButtonWhite'
import { ButtonBlue } from '../../Buttons/ButtonBlue'
const ScanInputChangeCameraModal = ({ showModal, setShowModal }) => {

    const initialState = getScanCamera() ? getScanCamera() : '';

    const [selectedCamera, setSelectedCamera] = useState(initialState);

    const [cameras, setCameras] = useState([]);

    const handleClose = () => {
        setShowModal();
        setSelectedCamera(initialState);
    }

    const handleSetCameraForScan = () => {
        setScanCamera(selectedCamera);
        window.location.reload()
        // setShowModal();
    }

    useEffect(() => {
        if (showModal === true) {
            const getCameras = async () => {
                try {
                    const devices = await navigator.mediaDevices.enumerateDevices();
                    const videoDevices = devices.filter(device => device.kind === 'videoinput');
                    setCameras(videoDevices);
                } catch (error) {
                    console.error('Error getting camera devices:', error);
                }
            }
            getCameras();
        }
    }, [showModal])

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={handleClose}
        >
            <div>
                <h5 className='text-center custom-h5'>
                    {t('CHOOSE_CAMERA')}
                </h5>
                <div>
                    {cameras.map((camera, idx) =>
                        <div className="form-check" key={idx}>
                            <input
                                className="form-check-input"
                                type="radio"
                                id="flexRadioDefault1"
                                name="scanCamera"
                                onChange={() => setSelectedCamera(camera.deviceId)}
                                checked={camera.deviceId === selectedCamera}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="scanCamera"
                            >
                                {camera.label || `Cámara ${idx + 1}`}
                            </label>
                        </div>
                    )}
                </div>
                <div className="d-flex justify-content-sm-end justify-content-center gap-4">
                    <div>
                        <ButtonWhite
                            onClick={handleClose}
                            className='text-dark shadow-none'
                        >
                            {t('CANCEL')}
                        </ButtonWhite>
                    </div>
                    <div>
                        <ButtonBlue
                            onClick={handleSetCameraForScan}
                        >
                            {t('APPLY')}
                        </ButtonBlue>
                    </div>
                </div>
            </div>
        </CustomModal>
    )
}

export default ScanInputChangeCameraModal